module.exports = __webpack_public_path__ + "static/media/fuel-system-cleaning-red.1fb29905.svg";